module.exports = __webpack_public_path__ + "img/spec.a12da337.svg";